
import { defineComponent } from 'vue'

// paper information
interface PaperInfo {
  title: string,
  author: string,
  arxiv?: string,
  publisher: string,
  isbn: string,
  year: number,
  url?: string,
  note?: string,
  bibtex: string
}

export default defineComponent({
  data () {
    return {
      books: [
        {
          title: 'Modern Classification Theory of Superconducting Gap Nodes',
          author: '<u>Shuntaro Sumita</u>',
          publisher: 'Springer Singapore',
          isbn: '978-981-33-4264-4',
          year: 2021,
          url: 'https://www.springer.com/jp/book/9789813342637',
          note: '[Reproduced from the PhD thesis as the series "Springer Theses"].',
          bibtex:
          `@book{Sumita2021_book,
  title = {Modern Classification Theory of Superconducting Gap Nodes},
  author = {Shuntaro Sumita},
  publisher = {Springer},
  address = {Singapore},
  year = {2021},
  doi = {10.1007/978-981-33-4264-4},
  url = {https://doi.org/10.1007/978-981-33-4264-4}
}`
        }
      ] as PaperInfo[]
    }
  }
})
